import "./App.css";
import Dictionary from "./Dictionary";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="App-header"></header>
        <main>
          <Dictionary defaultKeyword="sunset" />
        </main>
        <footer>
          <code>
            Coded by Hana Ismail | GitHub Repository{" "}
            <a
              href="https://github.com/ismahaa94/dictionary-react"
              target="_blank"
              rel="noopener noreferrer"
            >
              Link
            </a>{" "}
            | Hosted on Netlify
          </code>
        </footer>
      </div>
    </div>
  );
}
